<template>
  <modal titulo="Exportar XLS Personalizado - Matrícula" :loading="loading">
    <card titulo="Configurar Campos">
      <card-content>

        <div class="row mb-3">
          <div class="col-3">
            <v-input v-model="novoCampo.coluna" label="Coluna" type="select"
                     :options="colunasDisponiveis" />
          </div>
          <div class="col-7">
            <v-input v-model="novoCampo.campo" label="Campo" type="select"
                     :options="camposDisponiveis" />
          </div>
          <div class="col-2 d-flex align-items-end">
            <v-button :run="adicionar" class="btn btn-outline-primary btn-sm w-100">
              <i class="fa fa-plus mr-1"></i> Adicionar
            </v-button>
          </div>
        </div>

      </card-content>
    </card>

    <card titulo="Campos Selecionados" class="mt-3">
      <card-content>
        <div v-if="campos.length === 0" class="text-muted text-center py-3">
          Nenhum campo adicionado. Selecione os campos e colunas acima.
        </div>
        <card-table v-else>
          <thead>
            <tr>
              <th>Coluna</th>
              <th>Campo</th>
              <th width="80px" class="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in camposOrdenados" :key="'campo_'+idx">
              <td><strong>{{ item.colunaLabel }}</strong></td>
              <td>{{ getLabelCampo(item.campo) }}</td>
              <td class="text-center">
                <a @click.prevent="remover(idx)" class="icon text-danger pointer">
                  <i class="fa fa-times"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </card-table>
      </card-content>
    </card>

    <template #footer>
      <button type="button" @click.prevent="cancelar()" class="btn btn-outline-secondary mr-auto">
        Cancelar
      </button>
      <v-button :run="exportar" class="btn btn-primary" :desabilitado="campos.length === 0">
        <i class="far fa-file-excel mr-1"></i> Exportar XLS
      </v-button>
    </template>
  </modal>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import ArquivoRelatorioBusiness from "@/business/relatorios/ArquivoRelatorioBusiness";
import ExportUtils from "@/commons/ExportUtils";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import Modal from "@/components/Modal.vue";

const COLUNAS_PLANILHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(l => ({ id: l, nome: `Coluna ${l}` }));
const CACHE_KEY = 'exportacao-matricula-personalizada';

export default {
  name: "ExportarXLSPersonalizadoMatricula",
  components: {Modal, Card, CardContent, CardTable },
  props: {
    filtros: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      campos: [],
      camposOpcoes: [],
      novoCampo: { coluna: null, campo: null }
    }
  },
  computed: {
    colunasDisponiveis() {
      const usadas = this.campos.map(c => c.coluna);
      return COLUNAS_PLANILHA.filter(c => !usadas.includes(c.id));
    },
    camposDisponiveis() {
      const usados = this.campos.map(c => c.campo);
      return this.camposOpcoes.filter(c => !usados.includes(c.id));
    },
    camposOrdenados() {
      return [...this.campos].sort((a, b) => a.coluna.localeCompare(b.coluna));
    }
  },
  methods: {
    getLabelCampo(campoId) {
      const campo = this.camposOpcoes.find(c => c.id === campoId);
      return campo ? campo.nome : campoId;
    },

    adicionar() {
      if (!this.novoCampo.coluna || !this.novoCampo.campo) {
        FrontBusiness.showWarn('', 'Selecione a coluna e o campo.');
        return;
      }
      this.campos.push({
        coluna: this.novoCampo.coluna,
        colunaLabel: `Coluna ${this.novoCampo.coluna}`,
        campo: this.novoCampo.campo,
        ordem: COLUNAS_PLANILHA.findIndex(c => c.id === this.novoCampo.coluna)
      });
      this.novoCampo = { coluna: null, campo: null };
      this.salvarCache();
    },

    remover(idx) {
      const sorted = this.camposOrdenados;
      const item = sorted[idx];
      const realIdx = this.campos.findIndex(c => c.coluna === item.coluna && c.campo === item.campo);
      if (realIdx > -1) {
        this.campos.splice(realIdx, 1);
        this.salvarCache();
      }
    },

    async exportar() {
      const camposPersonalizados = this.camposOrdenados.map((c) => ({
        campo: c.campo,
        coluna: c.coluna
      }));

      const forms = {
        ...this.filtros,
        camposPersonalizados
      };

      try {
        await ArquivoRelatorioBusiness.save("EXPORTAR_INDICADOR_REAL_PERSONALIZADO", forms, "XLSX");
        FrontBusiness.showSuccess('', 'Relatório adicionado à fila de processo.');
        FrontBusiness.closeModal(true);
        ExportUtils.openRelatorio({ identificacao: "EXPORTAR_INDICADOR_REAL_PERSONALIZADO" });
      } catch (e) {
        FrontBusiness.showError('Erro ao exportar', e?.message || e);
      }
    },

    cancelar() {
      FrontBusiness.closeModal();
    },

    salvarCache() {
      try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(this.campos));
      } catch (e) { /* ignore */ }
    },

    carregarCache() {
      try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
          this.campos = JSON.parse(cached);
        }
      } catch (e) { /* ignore */ }
    },

    async carregarCampos() {
      this.loading = true;
      try {
        this.camposOpcoes = await ArquivoRelatorioBusiness.getCamposExportacaoMatricula();
      } catch (e) {
        FrontBusiness.showError('Erro ao carregar campos', e?.message || e);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.carregarCampos().then(() => {
      this.carregarCache();
    });
  }
}
</script>
